import {
  //
  ADD_RESIDENCE,
  ADD_RESIDENCE_FAILURE,
  ADD_RESIDENCE_SUCCESS,
  //
  DELETE_RESIDENCE,
  DELETE_RESIDENCE_FAILURE,
  DELETE_RESIDENCE_SUCCESS,
  //
  EDIT_RESIDENCE,
  EDIT_RESIDENCE_FAILURE,
  EDIT_RESIDENCE_SUCCESS,
  //
  FETCH_RESIDENCE,
  FETCH_RESIDENCE_FAILURE,
  FETCH_RESIDENCE_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  DELETE_RESIDENCE_NOTE,
  DELETE_RESIDENCE_NOTE_FAILURE,
  DELETE_RESIDENCE_NOTE_SUCCESS,
  //
  DELETE_RESIDENCE_REMINDER_NOTE,
  DELETE_RESIDENCE_REMINDER_NOTE_FAILURE,
  DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  OPEN_FAMILY_ADD_MODAL,
  CLOSE_FAMILY_ADD_MODAL,
  //
  ADD_RESIDENCE_NOTE,
  ADD_RESIDENCE_NOTE_SUCCESS,
  ADD_RESIDENCE_NOTE_FAILURE,
  //
  FETCH_RESIDENCE_NOTES,
  FETCH_RESIDENCE_NOTES_FAILURE,
  FETCH_RESIDENCE_NOTES_SUCCESS,
  //
  ADD_RESIDENCE_REMINDER,
  ADD_RESIDENCE_REMINDER_SUCCESS,
  ADD_RESIDENCE_REMINDER_FAILURE,
  //
  FETCH_RESIDENCE_REMINDERS,
  FETCH_RESIDENCE_REMINDERS_FAILURE,
  FETCH_RESIDENCE_REMINDERS_SUCCESS,
  //
  ADD_RESIDENCE_FAMILY_MEMBER,
  ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  ADD_RESIDENCE_FAMILY_MEMBER_FAILURE,
  //
  EDIT_RESIDENCE_FAMILY_MEMBER,
  EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE,
  //
  FETCH_RESIDENCE_FAMILY_MEMBERS,
  FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE,
  FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS,
  //
  GET_FAMILY_VIEW_DATA,
  GET_FAMILY_VIEW_DATA_FAILURE,
  GET_FAMILY_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchResidence = (payload) => ({
  type: FETCH_RESIDENCE,
  payload,
});
export const fetchResidenceSuccess = (payload) => ({
  type: FETCH_RESIDENCE_SUCCESS,
  payload,
});
export const fetchResidenceFailure = (payload) => ({
  type: FETCH_RESIDENCE_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addResidence = (payload) => ({
  type: ADD_RESIDENCE,
  payload,
});
export const addResidenceSuccess = (payload) => ({
  type: ADD_RESIDENCE_SUCCESS,
  payload,
});
export const addResidenceFailure = (payload) => ({
  type: ADD_RESIDENCE_FAILURE,
  payload,
});
// EDIT
export const editResidence = (payload) => ({
  type: EDIT_RESIDENCE,
  payload,
});
export const editResidenceSuccess = (payload) => ({
  type: EDIT_RESIDENCE_SUCCESS,
  payload,
});
export const editResidenceFailure = (payload) => ({
  type: EDIT_RESIDENCE_FAILURE,
  payload,
});
// DELETE
export const deleteResidence = (payload) => ({
  type: DELETE_RESIDENCE,
  payload,
});
export const deleteResidenceSuccess = (payload) => ({
  type: DELETE_RESIDENCE_SUCCESS,
  payload,
});
export const deleteResidenceFailure = (payload) => ({
  type: DELETE_RESIDENCE_FAILURE,
  payload,
});
// DELETE Residence Note
export const deleteResidenceNote = (payload) => ({
  type: DELETE_RESIDENCE_NOTE,
  payload,
});
export const deleteResidenceNoteSuccess = (payload) => ({
  type: DELETE_RESIDENCE_NOTE_SUCCESS,
  payload,
});
export const deleteResidenceNoteFailure = (payload) => ({
  type: DELETE_RESIDENCE_NOTE_FAILURE,
  payload,
});
// DELETE Residence Reminder
export const deleteResidenceReminderNote = (payload) => ({
  type: DELETE_RESIDENCE_REMINDER_NOTE,
  payload,
});
export const deleteResidenceReminderNoteSuccess = (payload) => ({
  type: DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS,
  payload,
});
export const deleteResidenceReminderNoteFailure = (payload) => ({
  type: DELETE_RESIDENCE_REMINDER_NOTE_FAILURE,
  payload,
});
//
export const openNoteAddModal = (payload) => ({
  type: OPEN_NOTE_ADD_MODAL,
  payload,
});
export const closeNoteAddModal = (payload) => ({
  type: CLOSE_NOTE_ADD_MODAL,
  payload,
});
//
export const openReminderAddModal = (payload) => ({
  type: OPEN_REMINDER_ADD_MODAL,
  payload,
});
export const closeReminderAddModal = (payload) => ({
  type: CLOSE_REMINDER_ADD_MODAL,
  payload,
});
//
export const openFamilyAddModal = (payload) => ({
  type: OPEN_FAMILY_ADD_MODAL,
  payload,
});
export const closeFamilyAddModal = (payload) => ({
  type: CLOSE_FAMILY_ADD_MODAL,
  payload,
});
// ADD RESIDENCE NOTE
export const addResidenceNote = (payload) => ({
  type: ADD_RESIDENCE_NOTE,
  payload,
});
export const addResidenceNoteSuccess = (payload) => ({
  type: ADD_RESIDENCE_NOTE_SUCCESS,
  payload,
});
export const addResidenceNoteFailure = (payload) => ({
  type: ADD_RESIDENCE_NOTE_FAILURE,
  payload,
});
// List Note
export const fetchResidenceNotes = (payload) => ({
  type: FETCH_RESIDENCE_NOTES,
  payload,
});
export const fetchResidenceNotesSuccess = (payload) => ({
  type: FETCH_RESIDENCE_NOTES_SUCCESS,
  payload,
});
export const fetchResidenceNotesFailure = (payload) => ({
  type: FETCH_RESIDENCE_NOTES_FAILURE,
  payload,
});
// ADD RESIDENCE REMINDER
export const addResidenceReminder = (payload) => ({
  type: ADD_RESIDENCE_REMINDER,
  payload,
});
export const addResidenceReminderSuccess = (payload) => ({
  type: ADD_RESIDENCE_REMINDER_SUCCESS,
  payload,
});
export const addResidenceReminderFailure = (payload) => ({
  type: ADD_RESIDENCE_REMINDER_FAILURE,
  payload,
});
// List Residence Reminder
export const fetchResidenceReminders = (payload) => ({
  type: FETCH_RESIDENCE_REMINDERS,
  payload,
});
export const fetchResidenceRemindersSuccess = (payload) => ({
  type: FETCH_RESIDENCE_REMINDERS_SUCCESS,
  payload,
});
export const fetchResidenceRemindersFailure = (payload) => ({
  type: FETCH_RESIDENCE_REMINDERS_FAILURE,
  payload,
});
// ADD FAMILY MEMBER
export const addResidenceFamilyMember = (payload) => ({
  type: ADD_RESIDENCE_FAMILY_MEMBER,
  payload,
});
export const addResidenceFamilyMemberSuccess = (payload) => ({
  type: ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  payload,
});
export const addResidenceFamilyMemberFailure = (payload) => ({
  type: ADD_RESIDENCE_FAMILY_MEMBER_FAILURE,
  payload,
});
// EDIT FAMILY MEMBER
export const editResidenceFamilyMember = (payload) => ({
  type: EDIT_RESIDENCE_FAMILY_MEMBER,
  payload,
});
export const editResidenceFamilyMemberSuccess = (payload) => ({
  type: EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  payload,
});
export const editResidenceFamilyMemberFailure = (payload) => ({
  type: EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE,
  payload,
});
// List Residence Family Member
export const fetchResidenceFamilyMembers = (payload) => ({
  type: FETCH_RESIDENCE_FAMILY_MEMBERS,
  payload,
});
export const fetchResidenceFamilyMembersSuccess = (payload) => ({
  type: FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS,
  payload,
});
export const fetchResidenceFamilyMembersFailure = (payload) => ({
  type: FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE,
  payload,
});
// View
export const getFamilyViewData = (payload) => ({
  type: GET_FAMILY_VIEW_DATA,
  payload,
});
export const getFamilyViewDataSuccess = (payload) => ({
  type: GET_FAMILY_VIEW_DATA_SUCCESS,
  payload,
});
export const getFamilyViewDataFailure = (payload) => ({
  type: GET_FAMILY_VIEW_DATA_FAILURE,
  payload,
});
